module.exports = __webpack_public_path__ + "img/treatments-history-desktop-ru.a3df6566.jpg";